<template>
  <div class="baxia-page">
    <!-- 顶部banner -->
    <img class="banner-img" src="/static/images/bx/banner.png">
    
    <!-- 复苏图标 -->
    <img class="fusu-img" src="/static/images/bx/fusu.png">
    
    <!-- 春天图标 -->
    <img class="spring-img" src="/static/images/bx/spring.png">
    
    <!-- Trace ID -->
    <div class="trace-id">
      <span>Trace ID： {{ code }}</span>
    </div>
    
    <!-- 日志图片 -->
    <img v-if="isProductValid" class="log-img" src="/static/images/bx/log.png">
    
    <!-- 信息文字 -->
    <div v-if="isProductValid" class="info-line1">
      <span>品牌：  王溪·Vansia</span>
      <span>状态：  已激活</span>
    </div>
    
    <div v-if="isProductValid" class="info-line2">
      <span>首次查询时间：  {{ firstQueryTime }}</span>
    </div>
    
    <!-- 追溯图片 -->
    <img v-if="isProductValid" class="trace-img" src="/static/images/bx/trace.png" @click="handleTraceClick">
    
    <!-- 积分活动 -->
    <div v-if="isProductValid" class="points-activity">
      <div class="left-text">
        <span class="text-item">领取积分</span>
        <span class="text-item">兑换赠品</span>
      </div>
      <div class="right-section">
        <span class="divider">|</span>
        <span class="clickable" @click="handleJoinClick">点击</span>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-area">
      <!-- 巴夏首页内容 -->
    </div>
    
    <!-- 底部图片 -->
    <img src="/static/images/bx/bottom.png" class="bottom-img">
  </div>
</template>

<style scoped>
.baxia-page {
  width: 100vw;
  min-height: 100vh;
  background-color: rgb(246, 246, 246);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}

.banner-img {
  width: 100vw;
  height: auto;
  margin-top: 0;
}

.fusu-img {
  margin-top: 3vh;
  width: 20vw;
  height: auto;
}

.spring-img {
  margin-top: 2vh;
  width: 30vw;
  height: auto;
}

.trace-id {
  margin-top: 3vh;
  width: 80vw;
  background-color: white;
  border-radius: 2vw;
  padding: 1.5vh 3vw;
  text-align: center;
}

.trace-id span {
  font-size: 4vw;
  font-weight: bold;
  color: black;
}

.log-img {
  margin-top: 2vh;
  width: 50vw;
  height: auto;
}

.info-line1 {
  margin-top: 2.5vh;
  width: 70vw;
  display: flex;
  justify-content: space-between;
  font-size: 3.5vw;
  color: rgb(47, 47, 47);
}

.info-line2 {
  margin-top: 1.4vh;
  width: 70vw;
  text-align: center;
  font-size: 3.5vw;
  color: rgb(47, 47, 47);
}

.trace-img {
  margin-top: 2vh;
  width: 40vw;
  height: auto;
}

.points-activity {
  margin-top: 2vh;
  width: 70vw;
  background-color: white;
  border-radius: 2vw;
  padding: 1vh 3vw;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-text {
  flex: 0.7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 3.5vw;
  color: rgb(47, 47, 47);
}

.left-text .text-item {
  flex: 1;
  text-align: center;
}

.right-section {
  flex: 0.3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 2vw;
}

.points-activity .divider {
  margin-right: 0.2vw;
  margin-left: 0.5vw;
  color: rgb(47, 47, 47);
}

.points-activity .clickable {
  font-size: 3.5vw;
  color: rgb(47, 47, 47);
  cursor: pointer;
}

.content-area {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bottom-img {
  margin-bottom: 3vh;
  width: 70vw;
  height: auto;
}

/* 小屏幕设备适配 (iPhone 5/SE等) */
@media screen and (max-height: 667px) {
  .banner-img {
    max-height: 35vh;
    object-fit: cover;
  }
  
  .fusu-img {
    width: 15vw;
  }
  
  .spring-img {
    width: 25vw;
  }
  
  .trace-id {
    margin-top: 3vh;
    padding: 1vh 2vw;
  }
  
  .log-img {
    width: 40vw;
  }
  
  .info-line1, .info-line2 {
    font-size: 3vw;
  }
  
  .trace-img {
    width: 30vw;
  }
  
  .points-activity {
    margin-top: 3vh;
    padding: 1vh 2vw;
  }
  
  .left-text, .points-activity .clickable {
    font-size: 3vw;
  }
}
</style>

<script>
import { queryAnti, getWechatAuth } from '../../api/api'

export default {
  name: 'BaXiaIndex',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wx1e7875f5abb1fa0a' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138823261350' : '138482046494',
      code: '', // 扫码或输入的数码
      isProductValid: false, // 产品是否有效
      firstQueryTime: '', // 首次查询时间
      deptId: '' // 部门ID
    }
  },
  methods: {
    // 查询防伪信息
    queryAntiInfo() {
      queryAnti(this.code, this.eno).then(res => {
        console.log('查询防伪信息结果:', res)
        // 判断返回的replyCode
        if (res.data && res.data.data && (res.data.data.replyCode === "300101" || res.data.data.replyCode === "300102")) {
          // 正常展示
          this.isProductValid = true
          // 获取首次查询时间
          if (res.data.data.firstQueryTime) {
            this.firstQueryTime = res.data.data.firstQueryTime
          }
          // 记录deptId
          if (res.data.data.deptId) {
            this.deptId = res.data.data.deptId
          }
        } else {
          // 产品无效，显示错误信息
          this.isProductValid = false
          alert('此码不存在，谨防仿冒')
        }
      }).catch(err => {
        console.error('查询防伪信息失败:', err)
        this.isProductValid = false
        alert('查询失败，请重试')
      })
    },
    handlePointsClick() {
      // 处理积分活动点击事件
      alert('积分活动功能开发中...');
    },
    handleTraceClick() {
      // 跳转到trace页面，并传递code和deptId参数
      this.$router.push({ 
        path: '/bxia/trace',
        query: {
          c: this.code,
          deptId: this.deptId
        }
      })
    },
    handleJoinClick() {
      const redirectUrl = window.location.origin + '/bxia/join'
      const params = new URLSearchParams()
      params.append('eno', this.eno)
      params.append('c', this.code)
      params.append('deptId', this.deptId)
      
      const fullRedirectUrl = redirectUrl + '?' + params.toString()
      
      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data
        window.location.href = data
      }).catch(err => {
        alert("获取微信授权失败" + err)
      })
    }
  },
  mounted() {
    // 初始化
    // 从路由参数中获取c
    if (this.$route.query.c) {
      this.code = this.$route.query.c
      // 如果this.code有值，则取前16位重新赋值
      if (this.code) {
        this.code = this.code.substring(0, 16)
      }
      // 调用查询防伪信息方法
      this.queryAntiInfo()
    } else {
      alert('请重新扫码进行查询')
      // 跳转回scan页面
      this.$router.push({ 
        path: '/bxia/scan' 
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/BaXia/Index.vue